export default __webpack_public_path__ + "static/media/wechat-qrcode.5eccffa0.jpeg";